import React, { useCallback, useEffect, useState } from "react";
import '../style.scss';
import { getAllParameters } from "../../parameters/helper/api";
import { checkVideoPlatform, startLoader, stopLoader } from "../../../lib/utils";
import { isAuthenticated } from "../../../auth";
import { getAllTutorial, saveTutorial } from "../helper";
import Toast from "../../../lib/toast";

const CreateTutorial = (props) => {

  const [featureType, setFeatureType] = useState("GOS");
  const [currentElementId, setCurrentElementId] = useState("");

  const [selectedFeatureType, setSelectedFeatureType] = useState("");
  const [isFeatureTypeDropdownOpen, setIsFeatureTypeDropdownOpen] = useState(false);
  const [tutorialTitle, setTutorialTitle] = useState("");
  const [tutorialLink, setTutorialLink] = useState("");
  const [isButtonLock,setButtonLock] = useState(false);
  const [tutorial,setTutorial] = useState({
    gosFeature:{
      type:"gosFeature",
       name:"Gos Tutorials",
       contents:[]
    },
    workoutPlusFeature:{
      type:"workoutPlusFeature",
      name:"Workoutplus Tutorials",
      contents:[]
    }
  })
  const [parameters,setParameters] = useState([]);

  const {user,token} = isAuthenticated();
 
  const handleSelectFeatureType = (type) => {
    setFeatureType(type);
  }

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }

    if(id == "feature-type"){
      setIsFeatureTypeDropdownOpen(!isFeatureTypeDropdownOpen);
    }
  }

  const handleAddTutorial = () => {

    if(checkVideoPlatform(tutorialLink).error){
      new Toast({
        type:"warning",
        duration:3000,
        message:checkVideoPlatform(tutorialLink).error
      })
      return;
    }

    if(tutorialTitle && tutorialLink){
      let newTutorial = {
        title: tutorialTitle,
        link: tutorialLink
      }
      setTutorial(oldstate=>{
        if(featureType == "GOS"){
          let findIndex=oldstate.gosFeature.contents.findIndex(data=>data.name == selectedFeatureType);
          if(findIndex == -1){
            oldstate.gosFeature.contents.push({
              name:selectedFeatureType,
              videos:[
                {
                  ...newTutorial
                }
              ]
            });
          }else{
            oldstate.gosFeature.contents[findIndex].videos.push({...newTutorial});
          }
        }else{
          let findIndex=oldstate.workoutPlusFeature.contents.findIndex(data=>data.name == selectedFeatureType);
          if(findIndex == -1){
            oldstate.workoutPlusFeature.contents.push({
              name:selectedFeatureType,
              videos:[
                {
                  ...newTutorial
                }
              ]
            });
          }else{
            oldstate.workoutPlusFeature.contents[findIndex].videos.push({...newTutorial});
          }
        }
        return{...oldstate};
      })
    
      setTutorialTitle("");
      setTutorialLink("");
    }
  }

  const handleDeleteTutorial = (index) => {
    if(featureType == "GOS"){
      setTutorial(oldstate=>{
        let findIndex=oldstate.gosFeature.contents.findIndex(data=>data.name == selectedFeatureType);
        if(findIndex > -1){
          oldstate.gosFeature.contents[findIndex].videos.splice(index,1);
        }
        return{...oldstate};
      })
    }else{
      setTutorial(oldstate=>{
        let findIndex=oldstate.workoutPlusFeature.contents.findIndex(data=>data.name == selectedFeatureType);
        if(findIndex > -1){
          oldstate.workoutPlusFeature.contents[findIndex].videos.splice(index,1);
        }
        return{...oldstate};
      })
    }
  }

  const selectFeatureType = (data) => {
    setSelectedFeatureType(data);
    // setCurrentElementId("");
  }

  const SaveTutorial = async event =>{
    try{
      await startLoader();
      setButtonLock(true);
      const payload = {
        ...tutorial
      };
      const response = await saveTutorial(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:JSON.stringify(response.error)
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Tutorials saved successfully"
        })
        // props.toggleCreateTutorial()
      }
      setButtonLock(false);
      await stopLoader();
    }catch(error){
      await stopLoader();
      setButtonLock(false);
    }
  }

  const GetAllTutorials = async () =>{
    try{
      const param = {
        types:['workoutPlusFeature',"gosFeature"]
      };
      const response = await getAllTutorial(param);
      if(!response.error){
        setTutorial(oldstate=>{
          for(const data of response){
            if(data.type == "gosFeature"){
              oldstate.gosFeature.name=data.name;
              oldstate.gosFeature.type=data.type;
              oldstate.gosFeature.contents=data.contents;
            }else{
              oldstate.workoutPlusFeature.name=data.name;
              oldstate.workoutPlusFeature.type=data.type;
              oldstate.workoutPlusFeature.contents=data.contents;
            }
          }
          return {...oldstate};
        })
      }

    }catch(error){
      //error
    }
  }

  const GetAllParameters = async (type) =>{
    try{
      let params = {
        noLimit: 'noLimit',
        sortByInstafit: "sort",
        type
      }

      let response = await getAllParameters(user._id,token,params);

      if(!response.error){
        if(response.length) setSelectedFeatureType(response[0].name)
        setParameters(response);
      }
    }catch(error){
      //
    }
  }

  const getVideos = useCallback(()=>{
    let videos = []
    if(featureType == "GOS"){
      let index = tutorial.gosFeature.contents.findIndex(d=>d.name == selectedFeatureType);
      if(index>-1) videos = tutorial.gosFeature.contents[index].videos;
    }else{
      let index = tutorial.workoutPlusFeature.contents.findIndex(d=>d.name == selectedFeatureType);
      if(index>-1) videos = tutorial.workoutPlusFeature.contents[index].videos;
    }
    return videos;
  },[tutorial,selectedFeatureType,featureType])

  // useEffect(()=>{
  //   if((tutorial.gosFeature.name && tutorial.gosFeature.contents.length > 0) || (tutorial.workoutPlusFeature.name && tutorial.workoutPlusFeature.contents.length > 0)){
  //     setButtonLock(false);
  //   }else{
  //     setButtonLock(true);
  //   }
  // },[tutorial]);

  useEffect(async ()=>{
    try{
      await startLoader();
      await GetAllTutorials();
      await stopLoader();
    }catch(error){
      await stopLoader()
    }
  },[]);

  useEffect(async ()=>{
    try{
      await startLoader();
      await GetAllParameters(featureType == "GOS"?"gosFeature":"workoutPlusFeature");
      await stopLoader();
    }catch(error){
      await stopLoader()
    }
  },[featureType])

  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "0" : ""}}>
      <div className={`${window.innerWidth > 767 ? "global-modal-type-2 tutorial-modal flex-item" : "modal-container tutorial-modal-mobile flex-item"}`}>

        {
  window.innerWidth > 767 && (
    <div 
      className="d-flex w-full space-between modal-header-curved-bottom" 
      style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}
    >
      <div className='d-flex'>
        <svg className='flex-item m-r-12' width="24" height="24" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.2458 31.0271C17.0437 30.055 13.7132 29.5747 10.3676 29.6026C7.19227 29.6137 4.03587 30.0937 1 31.0271V2.78117C4.08184 1.69945 7.32441 1.15003 10.5896 1.1563C13.8763 1.15273 17.1403 1.70197 20.2458 2.78117" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.5566 31.0269C23.7431 30.0525 27.0593 29.5721 30.3904 29.6023C33.5883 29.6046 36.7679 30.0847 39.8246 31.0269V2.62512C36.7217 1.53592 33.456 0.986395 30.1684 1.00026C26.8962 0.995749 23.6466 1.54509 20.5566 2.62512" stroke="#ffffff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20.4004 2.78125V31.094" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10"/>
          <path d="M6.10547 9.12551C7.6737 8.60052 9.31367 8.32269 10.9669 8.30195C12.7395 8.28033 14.5031 8.55876 16.1834 9.12551" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M6.10547 13.7329C7.6737 13.2079 9.31367 12.9301 10.9669 12.9094C12.7395 12.8878 14.5031 13.1662 16.1834 13.7329" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M6.10547 18.3401C7.67248 17.8128 9.31399 17.5423 10.9669 17.5388C12.7018 17.5131 14.4283 17.7841 16.0724 18.3401" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M6.10547 22.9463C7.67124 22.4115 9.31278 22.1334 10.9669 22.1227C12.7389 22.0843 14.5041 22.3554 16.1834 22.924" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M33.6074 14.4897L28.3021 11.418C28.0453 11.2694 27.754 11.1912 27.4575 11.1914C27.1611 11.1916 26.8699 11.2701 26.6133 11.4191C26.3567 11.568 26.1438 11.7821 25.996 12.0399C25.8482 12.2976 25.7708 12.5898 25.7715 12.8871V19.0304C25.7708 19.3277 25.8482 19.6199 25.996 19.8777C26.1438 20.1354 26.3567 20.3495 26.6133 20.4985C26.8699 20.6474 27.1611 20.7259 27.4575 20.7261C27.754 20.7263 28.0453 20.6481 28.3021 20.4995L33.6074 17.4278C33.8658 17.2799 34.0806 17.0661 34.23 16.8081C34.3793 16.5501 34.458 16.2571 34.458 15.9588C34.458 15.6604 34.3793 15.3674 34.23 15.1094C34.0806 14.8514 33.8658 14.6376 33.6074 14.4897Z" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M1.53125 38.127H39.2459" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
          <path d="M9.25647 39.7306C10.1392 39.7306 10.8547 39.0131 10.8547 38.128C10.8547 37.2429 10.1392 36.5254 9.25647 36.5254C8.37377 36.5254 7.6582 37.2429 7.6582 38.128C7.6582 39.0131 8.37377 39.7306 9.25647 39.7306Z" stroke="#ffffff" stroke-width="1.8" stroke-miterlimit="10" stroke-linecap="round"/>
        </svg>
        <p className="flex-item modal-header-text" style={{color: "#ffffff"}}>Feature Tutorials</p>
      </div>
      <div onClick={()=>props.toggleCreateTutorial()} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#ffffff"}}>
        <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
        </svg>
      </div>
    </div>
  )
}

        <div className="tutorial-radio-group">
          <div onClick={()=>handleSelectFeatureType("GOS")} className="tutorial-radio-item">
            <input type="radio" checked={featureType == "GOS" && true}/>
            <p>GOS</p>
          </div>

          <div onClick={()=>handleSelectFeatureType("WP")} className="tutorial-radio-item">
            <input type="radio" checked={featureType == "WP" && true}/>
            <p>Workout Plus</p>
          </div>
        </div>


        <div className="d-flex p-l-12 p-r-12 p-t-12">
          <div onClick={toggleInputFields('feature-type')} className={`${isFeatureTypeDropdownOpen ||  selectedFeatureType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "1px solid var(--darkBlue)" : "" }}>
              <div className="flex-item d-flex" style={{marginTop: (isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "4px" : ""}}>
                <p className="placeholder-txt flex-item" style={{ fontSize: (isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "10px" : "16px", lineHeight: (isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "10px" : "14px", color: (isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Feature Type</p>
              </div>
              <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
                <svg className="flex-item" style={{ transform: isFeatureTypeDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                </svg>
              </div>
              <input id="feature-type" className={`${(isFeatureTypeDropdownOpen ||  selectedFeatureType) ? "active-input-field" : "inactive-input-field"} m-t-4`} type="text" placeholder="Select PT Package" value={selectedFeatureType ? selectedFeatureType : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
              {
                isFeatureTypeDropdownOpen && (
                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                    <div className="w-full">
                      {
                        parameters.map((parameter, index) => {
                          return (
                            <div onClick={()=>selectFeatureType(parameter.name)} className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">{parameter.name}</p>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )
              }
          </div>
        </div>

        <div className="dashboard-data-saperator flex-item" style={{margin:"20px 0"}}/>

        <div className="tutorial-field-row">

          <div onClick={toggleInputFields('tutorial-title')} className={`tutorial-field-half ${(currentElementId == 'tutorial-title' || tutorialTitle) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'tutorial-title' || tutorialTitle) ? "1px solid var(--darkBlue)" : "" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'tutorial-title' || tutorialTitle) ? "10px" : "14px", color: (currentElementId == 'tutorial-title' || tutorialTitle) ? "var(--darkBlue)" : "", transition: "180ms" }}>Tutorial Title</p>
            </div>
            <input value={tutorialTitle} onChange={(event)=>setTutorialTitle(event.target.value)} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'tutorial-title' || tutorialTitle) ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>

          <div onClick={toggleInputFields('tutorial-link')} className={`tutorial-field-half ${(currentElementId == 'tutorial-link' || tutorialLink) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'tutorial-link' || tutorialLink) ? "1px solid var(--darkBlue)" : "" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'tutorial-link' || tutorialLink) ? "10px" : "14px", color: (currentElementId == 'tutorial-link' || tutorialLink) ? "var(--darkBlue)" : "", transition: "180ms" }}>Tutorial Link</p>
            </div>
            <input value={tutorialLink} onChange={(event)=>setTutorialLink(event.target.value)} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'tutorial-link' || tutorialLink) ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>
        </div>

        <div className="w-full p-l-12 p-r-12 p-b-12">
          <div onClick={()=>handleAddTutorial()} className={`global-button-container ${(checkVideoPlatform(tutorialLink).platform && tutorialTitle)?"global-button-container-active":"global-button-container-inactive"} d-flex flex-item`} style={{borderRadius:"20px", height:"40px",pointerEvents:(checkVideoPlatform(tutorialLink).platform && tutorialTitle)?'auto':'none'}}>
            <p className="flex-item">Add Tutorial</p>
          </div>
        </div>

        {
          getVideos().length > 0 && (
            <div className="w-full p-l-12 p-r-12">
              <p className="m-t-12 m-b-12 font-weight-700 fs-16">Tutorials Added</p>
              {
                 getVideos().map((tutorial, index) => {
                  return(
                    <div className={`${featureType == "GOS" ? "gos-tutorial-video" : "tutorial-video"} bg-white m-b-8 d-flex space-between`}>
                      <div className="flex-item" style={{width:"80%"}}>
                        <div className="flex-item">
                          <p className="fs-14 font-weight-600">{tutorial.title}</p>
                        </div>
                        <div className="flex-item d-flex m-t-4">
                          <svg className="flex-item m-r-8" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11.5" fill="#f5f5f5"/>
                            <path d="M15.5341 10.178C16.5891 10.7436 16.5891 12.2564 15.5341 12.822L9.70874 15.945C8.70948 16.4808 7.5 15.7568 7.5 14.623V8.37697C7.5 7.24316 8.70948 6.51925 9.70874 7.05496L15.5341 10.178Z" fill="var(--darkBlue)"/>
                          </svg>
                          <a href={tutorial.link} target="_blank" className="fs-14 font-weight-700" style={{color:"var(--darkBlue)", fontStyle:"italic"}} rel="noreferrer">{tutorial.link && tutorial.link.length > 38 ? tutorial.link.slice(0, 38) + "..." : tutorial.link}</a>
                        </div>
                      </div>
                      <div onClick={()=>handleDeleteTutorial(index)} className="table-action-button d-flex cursor-pointer" style={{backgroundColor: "#FFE4E4", boxShadow:"none"}}>
                        <svg className="flex-item margin-auto" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.616 16.0005C2.168 16.0005 1.78667 15.8431 1.472 15.5285C1.15733 15.2138 1 14.8328 1 14.3855V2.00047H0V1.00047H4V0.230469H10V1.00047H14V2.00047H13V14.3855C13 14.8455 12.846 15.2298 12.538 15.5385C12.23 15.8471 11.8453 16.0011 11.384 16.0005H2.616ZM12 2.00047H2V14.3855C2 14.5648 2.05767 14.7121 2.173 14.8275C2.28833 14.9428 2.436 15.0005 2.616 15.0005H11.385C11.5383 15.0005 11.6793 14.9365 11.808 14.8085C11.9367 14.6805 12.0007 14.5391 12 14.3845V2.00047ZM4.808 13.0005H5.808V4.00047H4.808V13.0005ZM8.192 13.0005H9.192V4.00047H8.192V13.0005Z" fill="#E33A34"/>
                        </svg>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          )
        }

        <div className="w-full" style={{position:"absolute", bottom:0, padding:"12px"}}>
          <div onClick={isButtonLock?null:SaveTutorial} className={`global-button-container ${!isButtonLock?"global-button-container-active":"global-button-container-inactive"} d-flex flex-item`} style={{borderRadius:"20px", height:"40px",pointerEvents:!isButtonLock?'auto':'none'}}>
            <p className="flex-item">Save</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateTutorial;